import { uniq } from 'lodash'

export const getRoomsText = (data: {
  room: { name: string } | null
  coRoom: { name: string } | null
}) =>
  uniq([data.room, data.coRoom].flatMap(room => (room ? room.name : []))).join(
    ', '
  )
